<template>
  <div class="hide-content">
    <div
            v-for="(poster, index) in postersContent"
            :key="index"
            :id="`canvas-${poster.id}`"
            v-html="poster.content">
    </div>
  </div>
</template>

<script>
  export default {
    name: "posters-content",

    mounted() {
      this.$root.$on('get-posters-content', (postersContent) => this.postersContent = postersContent);
    },

    data() {
      return {
        postersContent: [],
      }
    },
  }
</script>

<style scoped>
  .hide-content {
    position: absolute;
    left: 30000px;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PostersContent.vue